import React from "react";
import imagen1 from "../assets/img1 (2).png";
import imagen2 from "../assets/img1 (7).png";
import imagen3 from "../assets/img1 (5).png";
import imagen4 from "../assets/img1 (3).png";
import imagen5 from "../assets/img1 (6).png";
import imagen6 from "../assets/img1 (4).png";
import imagen7 from "../assets/img1 (1).png";
import imagen8 from "../assets/img1 (8).png";
import imagen9 from "../assets/img1 (9).png";
import imagen10 from "../assets/img1 (10).png";
import imagen11 from "../assets/img1 (11).png";
import imagen12 from "../assets/img1 (12).png";
import imagen13 from "../assets/img1 (13).png";
import imagen14 from "../assets/img1 (14).png";

const Projects = () => {
  const projects = [
    {
      img: imagen1,
      title: "América Latina Genera",
      desc: "Sitio web de una iniciativa de ONU Mujeres.",
      live: "https://americalatinagenera.org",
      code: "#",
    },
    {
      img: imagen2,
      title: "Comercial Michelena",
      desc: "Portal comercial de un importador ferretero de la cuidad de Quito.",
      live: "https://comercialmichelena.com/",
      code: "#",
    },
    {
      img: imagen3,
      title: "PyColector",
      desc: "PyColector es un proyecto en consola, que permite la colección de datos desde Twitter",
      live: "#",
      code: "https://github.com/the97prime/Tweets",
    },
    {
      img: imagen4,
      title: "Programa Integra",
      desc: "Es el portal web de una iniciativa del Programa Integra, que busca la ayuda de personas en situación de movilidad",
      live: "https://programaintegra.com/",
      code: "#",
    },
    {
      img: imagen5,
      title: "GK City",
      desc: "Implementación de varios cambios y mantenimiento constante del portal web de noticias independiente más leido del Ecuador",
      live: "https://gk.city/",
      code: "https://github.com/the97prime",
    },
    {
      img: imagen6,
      title: "Calculadora Tributaria",
      desc: "Calculadora tributaria que permite saber cuanto pagar al SRI",
      live: "https://gk.city/2022/01/04/calculo-impuesto-renta-ecuador/",
      code: "https://github.com/the97prime/Calculadora-Tributaria",
    },
    {
      img: imagen7,
      title: "Voces Expertas",
      desc: "Portal en el que se muestra un directorio de mujeres expertas en diferentes campos",
      live: "https://voces-expertas.web.app/",
      code: "https://github.com/Tech-GK/Voces-Expertas",
    },
    {
      img: imagen8,
      title: "Nicole Pastry Arts",
      desc: "Tienda en línea y web de una de las pasteleras más importantes del país",
      live: "https://nicolepastryarts.com/",
      code: "#",
    },
    {
      img: imagen9,
      title: "Calculadora de Descuentos",
      desc: "Aplicación web que calcula rapidamente el valor de un articulo en descuento",
      live: "https://calcuadora-descuentos.web.app/",
      code: "https://github.com/the97prime/calculadora-descuentos",
    }
    ,
    {
      img: imagen10,
      title: "Atenea es Paridad",
      desc: "Sitio web de la iniciativa de PNUD y ONU Mujeres",
      live: "https://ateneaesparidad.com",
      code: "#",
    }
    ,
    {
      img: imagen11,
      title: "Melcocha Productions",
      desc: "Sitio web e Ecommerce, recuperado a manos de hackers",
      live: "https://melcochaproductions.com",
      code: "#",
    }
    ,
    {
      img: imagen12,
      title: "Compresor de Imágenes",
      desc: "Script de Pyhton que permite comprimir imágenes para usarlas dentro de sitios web",
      live: "#",
      code: "https://github.com/TeemoAFK/Compress-IMG",
    },
    {
      img: imagen13,
      title: "VA Abogados",
      desc: "Migración y Actualización de Contenidos de una página web de una firma de abogados",
      live: "https://vaabogados.legal",
      code: "#",
    },
    {
      img: imagen14,
      title: "Belen Ruales",
      desc: "Portafolio de una talentosa chelista de Alemania, originaria de Ecuador",
      live: "https://belenruales.com",
      code: "#",
    }
  ];

  return (
    <section className="bg-primary text-white px-5 py-32" id="projects">
      <div className="container mx-auto grid md:grid-cols-2 items-center md:justify-between">
        <div className="about-info mb-5">
          <h2 className="text-4xl font-bold mb-5 border-b-[5px] w-[180px] border-zinc-500 pb-2">
            Proyectos
          </h2>

          <p className="pb-5">
            Como desarrollador de software y diseñador web independiente, ofrezco servicios personalizados y de alta calidad para empresas y particulares. Utilizo las últimas tecnologías y metodologías para crear soluciones innovadoras y efectivas que ayudan a mis clientes a lograr sus objetivos. Desde la planificación y el diseño hasta la implementación y el mantenimiento, estoy comprometido a ofrecer soluciones a medida que satisfagan todas tus necesidades. Si buscas un servicio personalizado y profesional, no dudes en contactarme hoy mismo para descubrir cómo puedo ayudarte a llevar tu proyecto al siguiente nivel.
          </p>
        </div>

        <div className="about-img"></div>
      </div>

      <div className="projects container mx-auto grid md:grid-cols-3 gap-10">
        {projects.map((project, i) => {
          return (
            <div className="relative" key={i}>
              <img src={project.img} alt={project.title} />
              <div className="flex absolute left-0 right-0 top-[13px] bottom-0 mx-auto w-[90%] h-[90%]  bg-primary  opacity-0 duration-500 justify-center flex-col hover:opacity-100 ">
                <p className="py-5 text-center font-bold px-2 text-white">
                  {project.desc}
                </p>

                <div className="mx-auto">
                  <a
                    href={project.live}
                    className="px-5 py-2 rounded-xl bg-zinc-600 hover:bg-zinc-700 mr-5 font-bold"
                  >
                    Ver Proyecto
                  </a>
                  <a
                    href={project.code}
                    className="px-5 py-2 rounded-xl bg-zinc-700 hover:bg-zinc-800 font-bold"
                  >
                    Código
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Projects;
